<template>
  <div>
    <v-layout row justify-space-around>
      <v-flex xs2></v-flex>
      <v-flex xs3>
        <wz-avatar v-if="!disabled" :src="imageSrc" :tile="tile" :username="$store.getters['_User/fullName']" size="128px"></wz-avatar>
        <v-progress-circular v-else indeterminate class="primary--text" :size="128" :width="1"></v-progress-circular>
      </v-flex>
      <v-flex xs2></v-flex>
    </v-layout>
    <v-layout row justify-space-around>
      <v-flex xs1></v-flex>
      <v-flex xs10>
        <wz-file-selector @change="previewThumbnail" :value="textFieldValue" :disabled="disabled"></wz-file-selector>
      </v-flex>
      <v-flex xs1></v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tile: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      imageSrc: ''
    }
  },

  mounted () {
    if (!this.source || this.source === '') {
      this.imageSrc = this.$store.getters['_User/userAvatar']
    } else {
      this.imageSrc = this.source
    }
  },

  watch: {
    source (v) {
      this.imageSrc = v
    }
  },

  methods: {
    previewThumbnail (file) {
      this.imageSrc = file
      this.$emit('change', file)
    }
  },

  computed: {
    textFieldValue () {
      if (this.imageSrc) {
        if (this.imageSrc.length > 64) {
          return this.imageSrc.substr(0, 50) + '...'
        } else {
          return this.imageSrc
        }
      }
      return this.$store.state._User.id + '_avatar.jpg'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzImgUpload.vue